import { render, staticRenderFns } from "./GenCardPage.vue?vue&type=template&id=d0ec4174&scoped=true"
import script from "./GenCardPage.vue?vue&type=script&lang=js"
export * from "./GenCardPage.vue?vue&type=script&lang=js"
import style0 from "./GenCardPage.vue?vue&type=style&index=0&id=d0ec4174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ec4174",
  null
  
)

export default component.exports